import {
   ApplicationRef,
   Component,
   ComponentFactoryResolver,
   ElementRef,
   EventEmitter,
   forwardRef,
   HostListener,
   Injector,
   Input,
   OnChanges,
   OnDestroy,
   OnInit,
   Output,
   Renderer2,
   SimpleChanges,
   ViewContainerRef,
   ViewChild,
   ChangeDetectorRef
  } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
import { DatePickerInnerComponent } from './datepicker-inner.component';
import { DatepickerTemplateComponent } from './datepicker-template';
import { DatePickerComponent } from './datepicker.component';
import { DatepickerService } from './datepicker.shared.service';
import {
  getBrowserLocale,
  trasformToDate } from './datepicker-utility';
import {
  max,
  min
} from './axis-datepicker-customvalidator';
const moment = moment_;

export const DATEPICKER_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AxisDatePickerComponent),
  multi: true
};

export const DATEPICKER_VALIDATORS: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => AxisDatePickerComponent),
  multi: true
};

@Component({
  host: {
    class: 'axis-datepicker-wrapper'
  },
  selector: 'axis-datepicker,[axis-datepicker]',
  templateUrl: './axis-datepicker.component.html',
  providers: [
    DATEPICKER_CONTROL_VALUE_ACCESSOR,
    DATEPICKER_VALIDATORS,
    DatePickerInnerComponent
  ]
})
export class AxisDatePickerComponent
  implements OnInit, ControlValueAccessor, OnDestroy, OnChanges {
  formatedDate: string;
  dayRegExp: RegExp;
  monthRegExp: any;
  dlimiter: string;
  fDay: any;
  yearRegExp: any;
  @Input() font = 'custom';
  @Input() public customFormat;
  @Input() public placeholder = '';
  @Input() public locale;
  @Input() public customLocale;
  @Input() ariaLabel = 'please select a date';
  @Input() ariaLabelledby: string;
  /** array of custom css classes to be applied to targeted dates */
  @Input()
  public customClass: {
    date: Date;
    mode: string;
    clazz: string;
  }[];
  /** sets datepicker mode, supports: `day`, `month`, `year` */
  @Input() closeOnOutsideClick = true;
  @Input() public datepickerMode = 'day';
  @Input() public disableDays: number[] = [];
  @Input() public disableDates = [];
  @Input()
  public dateDisabled: {
    date: Date;
    mode: string;
  }[];
  @Input() disabled = false;
  /** format of day in month */
  @Input() public formatDay: string;
  /** format of month in year */
  @Input() public formatMonth: string;
  /** format of year in year range */
  @Input() public formatYear: string;
  /** format of day in week header */
  @Input() public formatDayHeader: string;
  /** format of title when selecting day */
  @Input() public formatDayTitle: string;
  /** format of title when selecting month */
  @Input() public formatMonthTitle: string;
  @Input() public isTodayVisiable = true;
  @Input() public isTodayVisible = true;
  @Input() public isClearVisible = true;
  /** default date to show if `ng-model` value is not specified */
  @Input() public initDate: Date;
  /**  oldest selectable date */
  @Input() public minDate: Date;
  /** number of months displayed in a single row of month picker */
  @Input() public monthColLimit: number;
  /** latest selectable date */
  @Input() public maxDate: Date;
  /** set lower datepicker mode, supports: `day`, `month`, `year` */
  @Input() public minMode: string;
  /** sets upper datepicker mode, supports: `day`, `month`, `year` */
  @Input() public maxMode: string;
  /** if false week numbers will be hidden */
  @Input() public onlyCurrentMonth: boolean;
  @Input() public open = false;
  @Input() required = false;
  /** if true shortcut`s event propagation will be disabled */
  @Input() public showWeeks = false;
  /** starting day of the week from 0-6 (0=Sunday, ..., 6=Saturday) */
  @Input() public startingDay: number;
  /** if true only dates from the currently displayed month will be shown */
  @Input() public shortcutPropagation: boolean;
  /** number of years displayed in a single row of year picker */
  @Input() public yearColLimit: number;
  /** array of disabled dates */
  /** number of years displayed in year selection */
  @Input() public yearRange: number;
  @Input() rel: string;
  @Input() isReadOnly = true; // Configurable input for Readonly, Readonly=false enables input to enter value
  @Input() ignoreTime = false; // Returns only date ignoring time and timezone
  @Input() isInsideModal = false;
  @Input() public isMaskedRequired = false;
  @Input() broswerLocale = false;
  @Input() browserLocale = false;
  @Input() useLocale: string;
  // Both broswerLocale and browserLocale fields have same purpose, just corrected spelling and kept both for zero impact.
  @Output() onDatepickerClose = new EventEmitter();
  @Output() valueChange = new EventEmitter();
  @Output() currentVal = new EventEmitter();
  @Output() onError = new EventEmitter();
  @ViewChild('input', { static: true }) inputRef;
  protected selectedDate: Date;
  private unbindDocumentEvent: Function;
  protected datePickerComponentRef: any;
  private selectOnDay = false;
  private selectOnMonth = false;
  private selectOnYear = false;
  private isInitialLoadWriteValue = true;
  public datePickerRef: any;
  private editedValue: any;
  public userFormatValues: any;
  public modelValue: Date;
  public onChange: any = Function.prototype;
  public onTouched: any = Function.prototype;
  public inputValue: any;
  public dateValueFormat: any = 'mediumDate';
  public top: any;
  public componentRef: any;
  private monthPickerRef = [];
  private yearPickerRef;
  private dayPickerRef;
  private containerEl = document.querySelector('body');
  public dateValue: string;
  public isValid: boolean;
  public userInput: any;
  public enteredValue: any;
  public errorMsg: string;
  public isValidFormat: boolean;
  public userFormat: any;
  private validator: any;
  private rangedate: any;
  private scrollYPosition: any;
  private localeLanguage: string;
  public localeArray = {
    'ar-SA' : 'dd/MM/yy',
    'bg-BG' : 'dd.M.yyyy',
    'ca-ES' : 'dd/MM/yyyy',
    'zh-TW' : 'yyyy/M/d',
    'zh' : 'YYYY-MM-DD',
    'cs-CZ' : 'd.M.yyyy',
    'da-DK' : 'dd-MM-yyyy',
    'de-DE' : 'dd.MM.yyyy',
    'el-GR' : 'd/M/yyyy',
    'en-US' : 'MM/dd/yyyy',
    'en' : 'MM/dd/yyyy',
    'fi-FI' : 'd.M.yyyy',
    'fr-FR' : 'dd/MM/yyyy',
    'fr' : 'dd/MM/yyyy',
    'he-IL' : 'dd/MM/yyyy',
    'hu-HU' : 'yyyy. MM. dd.',
    'is-IS' : 'd.M.yyyy',
    'it-IT' : 'dd/MM/yyyy',
    'ja-JP' : 'yyyy/MM/dd',
    'ja' : 'yyyy/MM/dd',
    'ko-KR' : 'yyyy-MM-dd',
    'nl-NL' : 'd-M-yyyy',
    'nb-NO' : 'dd.MM.yyyy',
    'pl-PL' : 'yyyy-MM-dd',
    'pt-BR' : 'd/M/yyyy',
    'ro-RO' : 'dd.MM.yyyy',
    'ru-RU' : 'dd.MM.yyyy',
    'hr-HR' : 'd.M.yyyy',
    'sk-SK' : 'd. M. yyyy',
    'sq-AL' : 'yyyy-MM-dd',
    'sv-SE' : 'yyyy-MM-dd',
    'th-TH' : 'd/M/yyyy',
    'tr-TR' : 'dd.MM.yyyy',
    'ur-PK' : 'dd/MM/yyyy',
    'id-ID' : 'dd/MM/yyyy',
    'uk-UA' : 'dd.MM.yyyy',
    'be-BY' : 'dd.MM.yyyy',
    'sl-SI' : 'd.M.yyyy',
    'et-EE' : 'd.MM.yyyy',
    'lv-LV' : 'yyyy.MM.dd.',
    'lt-LT' : 'yyyy.MM.dd',
    'fa-IR' : 'MM/dd/yyyy',
    'vi-VN' : 'dd/MM/yyyy',
    'hy-AM' : 'dd.MM.yyyy',
    'az-Latn-AZ' : 'dd.MM.yyyy',
    'eu-ES' : 'yyyy/MM/dd',
    'mk-MK' : 'dd.MM.yyyy',
    'af-ZA' : 'yyyy/MM/dd',
    'ka-GE' : 'dd.MM.yyyy',
    'fo-FO' : 'dd-MM-yyyy',
    'hi-IN' : 'dd-MM-yyyy',
    'ms-MY' : 'dd/MM/yyyy',
    'kk-KZ' : 'dd.MM.yyyy',
    'ky-KG' : 'dd.MM.yy',
    'sw-KE' : 'M/d/yyyy',
    'uz-Latn-UZ' : 'dd/MM yyyy',
    'tt-RU' : 'dd.MM.yyyy',
    'pa-IN' : 'dd-MM-yy',
    'gu-IN' : 'dd-MM-yy',
    'ta-IN' : 'dd-MM-yyyy',
    'te-IN' : 'dd-MM-yy',
    'kn-IN' : 'dd-MM-yy',
    'mr-IN' : 'dd-MM-yyyy',
    'sa-IN' : 'dd-MM-yyyy',
    'mn-MN' : 'yy.MM.dd',
    'gl-ES' : 'dd/MM/yy',
    'kok-IN' : 'dd-MM-yyyy',
    'syr-SY' : 'dd/MM/yyyy',
    'dv-MV' : 'dd/MM/yy',
    'ar-IQ' : 'dd/MM/yyyy',
    'zh-CN' : 'yyyy/M/d',
    'de-CH' : 'dd.MM.yyyy',
    'en-GB' : 'dd/MM/yyyy',
    'es-MX' : 'dd/MM/yyyy',
    'fr-BE' : 'd/MM/yyyy',
    'it-CH' : 'dd.MM.yyyy',
    'nl-BE' : 'd/MM/yyyy',
    'nn-NO' : 'dd.MM.yyyy',
    'pt-PT' : 'dd-MM-yyyy',
    'sr-Latn-CS' : 'd.M.yyyy',
    'sv-FI' : 'd.M.yyyy',
    'az-Cyrl-AZ' : 'dd.MM.yyyy',
    'ms-BN' : 'dd/MM/yyyy',
    'uz-Cyrl-UZ' : 'dd.MM.yyyy',
    'ar-EG' : 'dd/MM/yyyy',
    'zh-HK' : 'd/M/yyyy',
    'de-AT' : 'dd.MM.yyyy',
    'en-AU' : 'd/MM/yyyy',
    'es-ES' : 'dd/MM/yyyy',
    'es' : 'dd/MM/yyyy',
    'fr-CA' : 'yyyy-MM-dd',
    'sr-Cyrl-CS' : 'd.M.yyyy',
    'ar-LY' : 'dd/MM/yyyy',
    'zh-SG' : 'd/M/yyyy',
    'de-LU' : 'dd.MM.yyyy',
    'en-CA' : 'dd/MM/yyyy',
    'es-GT' : 'dd/MM/yyyy',
    'fr-CH' : 'dd.MM.yyyy',
    'ar-DZ' : 'dd-MM-yyyy',
    'zh-MO' : 'd/M/yyyy',
    'de-LI' : 'dd.MM.yyyy',
    'en-NZ' : 'd/MM/yyyy',
    'es-CR' : 'dd/MM/yyyy',
    'fr-LU' : 'dd/MM/yyyy',
    'ar-MA' : 'dd-MM-yyyy',
    'en-IE' : 'dd/MM/yyyy',
    'es-PA' : 'MM/dd/yyyy',
    'fr-MC' : 'dd/MM/yyyy',
    'ar-TN' : 'dd-MM-yyyy',
    'en-ZA' : 'yyyy/MM/dd',
    'es-DO' : 'dd/MM/yyyy',
    'ar-OM' : 'dd/MM/yyyy',
    'en-JM' : 'dd/MM/yyyy',
    'es-VE' : 'dd/MM/yyyy',
    'ar-YE' : 'dd/MM/yyyy',
    'en-029' : 'MM/dd/yyyy',
    'es-CO' : 'dd/MM/yyyy',
    'ar-SY' : 'dd/MM/yyyy',
    'en-BZ' : 'dd/MM/yyyy',
    'es-PE' : 'dd/MM/yyyy',
    'ar-JO' : 'dd/MM/yyyy',
    'en-TT' : 'dd/MM/yyyy',
    'es-AR' : 'dd/MM/yyyy',
    'ar-LB' : 'dd/MM/yyyy',
    'en-ZW' : 'M/d/yyyy',
    'es-EC' : 'dd/MM/yyyy',
    'ar-KW' : 'dd/MM/yyyy',
    'en-PH' : 'M/d/yyyy',
    'es-CL' : 'dd-MM-yyyy',
    'ar-AE' : 'dd/MM/yyyy',
    'es-UY' : 'dd/MM/yyyy',
    'ar-BH' : 'dd/MM/yyyy',
    'es-PY' : 'dd/MM/yyyy',
    'ar-QA' : 'dd/MM/yyyy',
    'es-BO' : 'dd/MM/yyyy',
    'es-SV' : 'dd/MM/yyyy',
    'es-HN' : 'dd/MM/yyyy',
    'es-NI' : 'dd/MM/yyyy',
    'es-PR' : 'dd/MM/yyyy',
    'am-ET' : 'd/M/yyyy',
    'tzm-Latn-DZ' : 'dd-MM-yyyy',
    'iu-Latn-CA' : 'd/MM/yyyy',
    'sma-NO' : 'dd.MM.yyyy',
    'mn-Mong-CN' : 'yyyy/M/d',
    'gd-GB' : 'dd/MM/yyyy',
    'en-MY' : 'd/M/yyyy',
    'prs-AF' : 'dd/MM/yy',
    'bn-BD' : 'dd-MM-yy',
    'wo-SN' : 'dd/MM/yyyy',
    'rw-RW' : 'M/d/yyyy',
    'qut-GT' : 'dd/MM/yyyy',
    'sah-RU' : 'MM.dd.yyyy',
    'gsw-FR' : 'dd/MM/yyyy',
    'co-FR' : 'dd/MM/yyyy',
    'oc-FR' : 'dd/MM/yyyy',
    'mi-NZ' : 'dd/MM/yyyy',
    'ga-IE' : 'dd/MM/yyyy',
    'se-SE' : 'yyyy-MM-dd',
    'br-FR' : 'dd/MM/yyyy',
    'smn-FI' : 'd.M.yyyy',
    'moh-CA' : 'M/d/yyyy',
    'arn-CL' : 'dd-MM-yyyy',
    'ii-CN' : 'yyyy/M/d',
    'dsb-DE' : 'd. M. yyyy',
    'ig-NG' : 'd/M/yyyy',
    'kl-GL' : 'dd-MM-yyyy',
    'lb-LU' : 'dd/MM/yyyy',
    'ba-RU' : 'dd.MM.yy',
    'nso-ZA' : 'yyyy/MM/dd',
    'quz-BO' : 'dd/MM/yyyy',
    'yo-NG' : 'd/M/yyyy',
    'ha-Latn-NG' : 'd/M/yyyy',
    'fil-PH' : 'M/d/yyyy',
    'ps-AF' : 'dd/MM/yy',
    'fy-NL' : 'd-M-yyyy',
    'ne-NP' : 'M/d/yyyy',
    'se-NO' : 'dd.MM.yyyy',
    'iu-Cans-CA' : 'd/M/yyyy',
    'sr-Latn-RS' : 'd.M.yyyy',
    'si-LK' : 'yyyy-MM-dd',
    'sr-Cyrl-RS' : 'd.M.yyyy',
    'lo-LA' : 'dd/MM/yyyy',
    'km-KH' : 'yyyy-MM-dd',
    'cy-GB' : 'dd/MM/yyyy',
    'bo-CN' : 'yyyy/M/d',
    'sms-FI' : 'd.M.yyyy',
    'as-IN' : 'dd-MM-yyyy',
    'ml-IN' : 'dd-MM-yy',
    'en-IN' : 'dd-MM-yyyy',
    'or-IN' : 'dd-MM-yy',
    'bn-IN' : 'dd-MM-yy',
    'tk-TM' : 'dd.MM.yy',
    'bs-Latn-BA' : 'd.M.yyyy',
    'mt-MT' : 'dd/MM/yyyy',
    'sr-Cyrl-ME' : 'd.M.yyyy',
    'se-FI' : 'd.M.yyyy',
    'zu-ZA' : 'yyyy/MM/dd',
    'xh-ZA' : 'yyyy/MM/dd',
    'tn-ZA' : 'yyyy/MM/dd',
    'hsb-DE' : 'd. M. yyyy',
    'bs-Cyrl-BA' : 'd.M.yyyy',
    'tg-Cyrl-TJ' : 'dd.MM.yy',
    'sr-Latn-BA' : 'd.M.yyyy',
    'smj-NO' : 'dd.MM.yyyy',
    'rm-CH' : 'dd/MM/yyyy',
    'smj-SE' : 'yyyy-MM-dd',
    'quz-EC' : 'dd/MM/yyyy',
    'quz-PE' : 'dd/MM/yyyy',
    'hr-BA' : 'd.M.yyyy.',
    'sr-Latn-ME' : 'd.M.yyyy',
    'sma-SE' : 'yyyy-MM-dd',
    'en-SG' : 'd/M/yyyy',
    'ug-CN' : 'yyyy-M-d',
    'sr-Cyrl-BA' : 'd.M.yyyy',
    'es-US' : 'M/d/yyyy'
};
    constructor(
    private el: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private datePicker: DatePickerInnerComponent,
    private resolver: ComponentFactoryResolver,
    private datepickerService: DatepickerService,
    private renderer: Renderer2,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private cdr:ChangeDetectorRef
  ) {}

  ngOnChanges(change: SimpleChanges) {
    if (change && change.datepickerMode && !change.datepickerMode.firstChange) {
      if (this.datepickerMode === 'day') {
        this.customFormat = 'MMM DD, YYYY';
      } else if (this.datepickerMode === 'month') {
        this.customFormat = 'MMM YYYY';
      } else {
        this.customFormat = 'YYYY';
      }
      this.initateDatePickerComponent();
    }
  }
  @HostListener('keyup', ['$event'])
  onKeyup(e: any) {
    e.preventDefault();
    if ((e.altKey === true && (e.key === 'ArrowDown' || e.keyCode === 40)) || (e.key === 'Enter')) {
      this.datepickerService.inputDateElement(this.el);
     this.createDatepickerComponent();
    }
  }

  ngOnInit() {
    this.localeLanguage = (this.useLocale) ? this.useLocale : getBrowserLocale();
    moment.locale(this.localeLanguage);
    this.initateDatePickerComponent();
  }

  initateDatePickerComponent() {
    if (!this.customFormat && !this.locale && !this.customLocale) {
      if (!this.useLocale) {
        if (this.datepickerMode === 'day') {
          this.customFormat = 'MMM DD, YYYY';
        } else if (this.datepickerMode === 'month') {
          this.customFormat = 'MMM YYYY';
        } else {
          this.customFormat = 'YYYY';
        }
      }
    }
    if (this.open) {
      this.createDatepickerComponent();
    }
    if (this.datepickerMode === 'day') {
      this.selectOnDay = true;
    } else {
      this.selectOnDay = false;
    }
    if (this.datepickerMode === 'month') {
      this.selectOnMonth = true;
    } else {
      this.selectOnMonth = false;
    }
    if (this.datepickerMode === 'year') {
      this.selectOnYear = true;
    } else {
      this.selectOnYear = false;
    }
    if (this.useLocale) {
      this.locale = this.useLocale;
    } else if (this.browserLocale) {
      this.locale = navigator.language;
    }
    if (this.locale) {
      if (this.localeArray[this.locale]) {
        if (this.useLocale) {
         this.customFormat = this.customFormat ? this.customFormat : this.localeArray[this.locale].toUpperCase();
        } else {
          this.customFormat = this.localeArray[this.locale].toUpperCase();
        }
      } else if (!this.useLocale) {
        this.errorMsg = 'Invalid format';
        this.isValidFormat = false;
        this.disabled = true;
        return;
      }
    } else if (this.customLocale) {
      for (const localekeys in this.customLocale) {
        if ( this.localeArray.hasOwnProperty(localekeys)) {
             this.localeArray[localekeys] = this.customLocale[localekeys];
             this.customFormat = this.localeArray[localekeys].toUpperCase();
        } else {
            this.customFormat = this.customLocale[localekeys].toUpperCase();
            this.userDateFormateValidation(this.customFormat);
            this.localeArray[localekeys] = this.customFormat;
        }
        }
    }
    this.userDateFormateValidation(this.customFormat);
  }
  errorHandler() {
    this.isValid = false;
    this.errorMsg = '';
    this.userInput = [];
    this.onChange(null);
    this.inputValue =  this.editedValue;
    this.onError.emit(this.inputRef.nativeElement.value);
    this.datepickerService.anounceModelUpdate(null);
  }
  // validates userFormat
  userDateFormateValidation(value) {
    // tslint:disable-next-line:max-line-length
    // const formateRegExp: RegExp = /^([M]{1,4}|[Mo]{2})([\/.,'' -]|[.][' '])([D|Do]{1,2})([\/.,'' -]|[,][' ']|[.][' '])([Y]{4}|[Y]{2})|([Y]{4}|[Y]{2})([\/.,'' -]|[.][' '])([M]{1,4}|[Mo]{2})([\/.,'' -]|[,][' ']||[.][' '])([D|Do]{1,2})|([D|Do]{1,2})([\/.,'' -]|[.][' '])([M]{1,4}|[Mo]{2})([\/.,'' -]|[,][' ']|[.][' '])([Y]{4}|[Y]{2})$/;
    // tslint:disable-next-line:max-line-length
    const formateRegExp: RegExp = /^([M]{1,4}|[Mo]{2})([\/.,'' -]|[.][' '])([D|Do]{1,2})([\/.,'' -]|[,][' ']|[.][' '])([Y]{4}|[Y]{2})|([Y]{4}|[Y]{2})([\/.,'' -]|[.][' '])([M]{1,4}|[Mo]{2})([\/.,'' -]|[,][' ']||[.][' '])([D|Do]{1,2})|([D|Do]{1,2})([\/.,'' -]|[.][' '])([M]{1,4}|[Mo]{2})([\/.,'' -]|[,][' ']|[.][' '])([Y]{4}|[Y]{2})|([M]{1,4}|[Mo]{2})([\/.,'' -]|[,][' ']|[.][' '])([Y]{4}|[Y]{2})|([Y]{2}|[Y]{4})$/;
    if (formateRegExp.test(value)) {
      this.userFormat = value;
      this.isValidFormat = true;
      // this.disabled = false;
    } else {
      this.errorMsg = 'Invalid format';
      this.isValidFormat = false;
      this.disabled = true;
    }
  }

  onValueChange(value) {
    this.localeLanguage = (this.useLocale) ? this.useLocale : getBrowserLocale();
    moment.locale(this.localeLanguage);
    this.editedValue = value;
    if (!this.isReadOnly) {
      this.onTouched();
    }
    if (value) {
      this.currentVal.emit(value);
    } else {
      this.currentVal.emit(null);
    }
    if (this.isValidFormat) {
      this.enteredValue = value;
      let validUserFormate = this.userFormat;
      if (!this.isReadOnly) {
        if (validUserFormate.includes('/') && this.enteredValue.includes('/')) {
          this.userInput = this.enteredValue.split('/');
          this.userFormatValues = validUserFormate.split('/');
          this.isValid = true;
          this.dlimiter = '/';
        } else if (
          validUserFormate.includes('.') &&
          this.enteredValue.includes('.')
        ) {
          this.userInput = this.enteredValue.split('.');
          this.userFormatValues = validUserFormate.split('.');
          this.isValid = true;
          this.dlimiter = '.';
        } else if (
          validUserFormate.includes('-') &&
          this.enteredValue.includes('-')
        ) {
          this.userInput = this.enteredValue.split('-');
          this.userFormatValues = validUserFormate.split('-');
          this.isValid = true;
          this.dlimiter = '-';
        } else if (
          validUserFormate.includes(',') &&
          this.enteredValue.includes(',')
        ) {
          this.enteredValue = this.enteredValue.replace(',', '');
          validUserFormate = validUserFormate.replace(',', '');
          this.userInput = this.enteredValue.split(' ');
          this.userFormatValues = validUserFormate.split(' ');
          this.isValid = true;
          this.dlimiter = ',';
        } else if (
          validUserFormate.includes(' ') &&
          this.enteredValue.includes(' ')
        ) {
          this.userInput = this.enteredValue.split(' ');
          this.userFormatValues = validUserFormate.split(' ');
          this.isValid = true;
          this.dlimiter = ' ';
        } else if (this.localeLanguage.slice(0, 2).toLowerCase() === 'ja') {
          if (this.datepickerMode === 'year') { // japan yearpicker
            this.customFormat = 'YYYY';
            this.userFormatValues = 'YYYY';
              this.enteredValue = trasformToDate(this.enteredValue, this.useLocale);
              if (this.enteredValue) {
                const year = this.enteredValue.split('/')[0];
                this.isValid = true;
                this.updateModel(0, year, 1);
                return ;
              } else {
                this.errorHandler();
              }
          } else {
            this.userFormat = 'YYYY/MM/DD';
            this.customFormat = 'YYYY/MM/DD';  // setting the format for japanese team
            validUserFormate = 'YYYY/MM/DD';
            this.userFormatValues = validUserFormate.split('/');
            this.isValid = true;
            this.enteredValue = trasformToDate(value, this.useLocale);
            const [year, month, day] = this.enteredValue.split('/');
            this.updateModel(month, year, day);
            return;
          }
        } else if (this.datepickerMode === 'year' && this.localeLanguage !== 'ja') { // english yearpicker
          this.isValid = true;
          this.customFormat = 'YYYY';
          this.userInput = this.enteredValue;
          this.userFormatValues = 'YYYY';
        }  else {
          this.errorHandler();
        }
        if (
          this.isValid !== false && this.userFormatValues && 
          this.userInput.length === this.userFormatValues.length
        ) {
          this.inputValidation();
        } else {
          if (this.enteredValue === '') {
            this.modelValue = null;
          }
          this.errorHandler();
        }
      }
    }
  }

  // validates Date, month and year
  inputValidation() {

    const sMon =
      this.userInput[this.userFormatValues.indexOf('M')] ||
      this.userInput[this.userFormatValues.indexOf('MM')] ||
      this.userInput[this.userFormatValues.indexOf('MMM')] ||
      this.userInput[this.userFormatValues.indexOf('MMMM')];

    const sDay =
      this.userInput[this.userFormatValues.indexOf('DD')] ||
      this.userInput[this.userFormatValues.indexOf('D')];

    const sYr =
      this.userInput[this.userFormatValues.indexOf('YYYY')] ||
      this.userInput[this.userFormatValues.indexOf('YY')];

    // if (sDay.length == 3) {
    //   sDay = sDay.substr(0, 1);
    // } else {
    //   sDay = sDay.substr(0, 2);
    // }

    this.fDay = sDay;
    if (this.datepickerMode !== 'year') {
    if (
      sMon.toString().toLowerCase() === 'apr' ||
      sMon.toString().toLowerCase() === 'april' ||
      sMon.toString().toLowerCase() === 'jun' ||
      sMon.toString().toLowerCase() === 'june' ||
      sMon.toString().toLowerCase() === 'sep' ||
      sMon.toString().toLowerCase() === 'september' ||
      sMon.toString().toLowerCase() === 'nov' ||
      sMon.toString().toLowerCase() === 'november' ||
      sMon === '04' ||
      sMon === '06' ||
      sMon === '09' ||
      sMon === '11' ||
      sMon === '4' ||
      sMon === '6' ||
      sMon === '9' ||
      sMon === '4th' ||
      sMon === '6th' ||
      sMon === '9th' ||
      sMon === '11th'
    ) {
      if (sDay <= 30) {
        this.fDay = sDay;
      } else {
        this.fDay = null;
      }
    } else if (sDay <= 31) {
      this.fDay = sDay;
    } else {
      this.fDay = null;
    }

    if (moment([sYr]).isLeapYear()) {
      if (
        sMon === 'Feb' ||
        sMon === '02' ||
        sMon === 'February' ||
        sMon === '2' ||
        sMon === '2nd'
      ) {
        if (sDay <= 29) {
          this.fDay = sDay;
        } else {
          this.fDay = null;
       }
      }
    } else {
      if (
        sMon === 'Feb' ||
        sMon === '02' ||
        sMon === 'February' ||
        sMon === '2' ||
        sMon === '2nd'
      ) {
        if (sDay <= 28) {
          this.fDay = sDay;
        } else {
          this.fDay = null;
        }
      }
    }
  }


  if (this.datepickerMode === 'month') { // for monthpicker mode
    const date = new Date(this.userInput);
    this.fDay = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Taking last date from month // Taking last date from month
    this.fDay =  this.fDay.getDate().toString();
  } else if (this.datepickerMode === 'year') { // for yearpicker mode
  this.updateModel(0, this.userInput, 1); // Taking first date from month
  }

if (this.datepickerMode !== 'year') {
    if (this.fDay ) {
      this.updateModel(sMon, sYr, this.fDay);
    } else {
      this.errorHandler();
    }
  }

    if (this.disableDays && this.disableDays.length > 0) { // check disable days input
      const formattedDate = moment(this.modelValue).format('MM/DD/YYYY');
      const date = new Date(formattedDate);
      if (this.datepickerService.isDisabledDay(this.disableDays, date)) {
        this.disableErrorHandler(); // validation for disable days
      }
    }

    if (this.disableDates && this.disableDates.length > 0) { // check disable dates input
      const formattedDate = moment(this.modelValue).format('MM/DD/YYYY');
      const date = new Date(formattedDate);
      if (this.datepickerService.isDisabledDate(this.disableDates, date)) {
        this.disableErrorHandler(); // validation for disable dates
      }
    }
}

disableErrorHandler() {
  this.modelValue = null;
  this.el.nativeElement.firstElementChild.children[0].value = '';
  this.errorMsg = '';
  this.onChange(null);
  this.datepickerService.anounceModelUpdate(null);
}

  updateModel(month, year, day): any {
    if (year && year.length === 4 && this.userFormatValues.includes('YYYY')) {
      this.yearRegExp = /^\d{4}$/;
    } else if (
      year &&
      year.length === 2 &&
      this.userFormatValues.includes('YY') || this.datepickerMode === 'year'
    ) {
      this.yearRegExp = /^(0?[1-9]|[1-9][0-9])$/;
    }

    if ((month && month.length >= 3 && ('MMM' || 'MMMM'))) {
      // tslint:disable-next-line:max-line-length
      this.monthRegExp = /(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|(Nov|Dec)(?:ember)?)$/;
    } else if (this.userFormat.includes('MM') || this.userFormat.includes('M') || this.datepickerMode === 'year') {
      this.monthRegExp = /^(0[0-9]|[0-9]|1[0-2])$/;
    }
    // tslint:disable-next-line:max-line-length
    if (this.userFormat.includes('DD') || this.userFormat.includes('D') || this.datepickerMode === 'month' || this.datepickerMode === 'year') {
      this.dayRegExp = /^(0[1-9]|[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
    }
    if (this.monthRegExp && this.yearRegExp && this.dayRegExp && day) {
      if (
        this.checkValidation(month, this.monthRegExp) &&
        this.checkValidation(year, this.yearRegExp) &&
        this.checkValidation(day, this.dayRegExp)
      ) {
        if (this.datepickerMode !== 'year') {
        month = moment(this.enteredValue, this.userFormat)['_pf'][
          'parsedDateParts'
        ][1];
      }
        const invalidDate = new Date(year, month, day);
        if (moment(this.enteredValue, this.userFormat).isValid()) {
          this.modelValue = invalidDate;
          this.datepickerService.anounceModelUpdate(this.modelValue);
          this.isValid = true;
          this.onDatepickerClose.emit(this.modelValue);
          this.dateValue = moment(this.modelValue).format(this.userFormat);
          this.inputRef.nativeElement.value = this.dateValue;
          if (this.minDate || this.maxDate) {
            // tslint:disable-next-line:no-unused-expression
            this.minDate && this.minDate.setHours(0, 0, 0, 0);
            // tslint:disable-next-line:no-unused-expression
            this.maxDate && this.maxDate.setHours(23, 59, 59);
            if (
              (this.minDate && this.modelValue < this.minDate) ||
              (this.maxDate && this.modelValue > this.maxDate)
            ) {
             this.isValid = false;
              this.errorMsg = '';
              this.userInput = [];
              this.onChange(this.modelValue);
              this.datepickerService.anounceModelUpdate(null);
            } else {
              this.onChange(this.modelValue);
            }
          } else {
            this.onChange(this.modelValue);
          }
        } else {
          this.errorHandler();
        }
      } else {
        this.errorHandler();
      }
    } else {
      this.errorHandler();
    }
  }

  // validates month date and year
  checkValidation(val, regExp: RegExp): boolean {
    if (this.datepickerMode !== 'year') {
    if (val) {
      val = val[0].toUpperCase() + val.substr(1).toLowerCase();
    }
  }
    if (regExp.test(val)) {
      return true;
    } else {
      return false;
    }
  }

  openDatePicker(event: Event) {
    event.preventDefault();
    if (this.isReadOnly || event.target['tagName'] !== 'INPUT') {
      this.createDatepickerComponent();
    }
    this.datepickerService.inputDateElement(this.el);
  }
  createDatepickerComponent() {
    if (!this.datePickerComponentRef) {
      this.datepickerService.useLocale = this.useLocale;
      this.datepickerService.setDatepickerInstance(this);
      const resolverFactory = this.resolver.resolveComponentFactory(
        DatePickerComponent
      );
      this.datePickerComponentRef = this.viewContainerRef.createComponent(
        resolverFactory
      );
      this.displayDatepicker();
      this.datePickerComponentRef.instance.closeEvent.subscribe(data => {
        this.modelValue = data;
        this.inputValue = this.getDate();
        this.editedValue = data;
        this.isValid = true;
        this.onClose(data);
        this.onChange(data);
      });
      this.datePickerComponentRef.instance.selectionDone.subscribe(data => {
        this.selectedDate = data;
        this.editedValue = data;
        this.modelValue = data;
        this.inputValue = this.getDate();
        this.isValid = true;
        this.onChange(data);
        this.removeDatePicker();
      });
      if (this.closeOnOutsideClick) {
        this.addDocumentListener();
      }
    }
  }
  displayDatepicker() {
    this.scrollYPosition = !document.body.classList.contains(
      'axis-tooltip-open'
    )
      ? window.pageYOffset
      : parseInt(document.body.style.top , 10) * -1;
    if (!document.body.classList.contains('axis-tooltip-open')) {
      document.body.style.top = -this.scrollYPosition + 'px';
      document.body.style.position = 'fixed';
      if (document.body.scrollHeight > window.innerHeight) {
        document.body.classList.add('axis-datepicker-open');
      } else {
        document.body.classList.add('axis-datepicker-hidden-scroll');
      }
    }
    const componentFactory = this.resolver.resolveComponentFactory(
      DatepickerTemplateComponent
    );
    this.componentRef = componentFactory.create(this.injector);
    this.applicationRef.attachView(this.componentRef.hostView);
    this.componentRef.location.nativeElement.appendChild(
      this.datePickerComponentRef.location.nativeElement
    );
    this.containerEl.appendChild(this.componentRef.location.nativeElement);
    this.calculatePosition();
  }
  hideDatepicker() {
    if (this.componentRef) {
      const menuElement = this.componentRef.location.nativeElement;
      if (menuElement && menuElement.parentNode) {
        menuElement.parentNode.removeChild(menuElement);
      }
      this.componentRef.destroy();
      if (!document.body.classList.contains('axis-tooltip-open')) {
        document.body.removeAttribute('style');
      }
    }
    if (!document.body.classList.contains('axis-tooltip-open')) {
      document.body.classList.remove('axis-datepicker-open');
      document.body.classList.remove('axis-datepicker-hidden-scroll');
      document.body.style.position = '';
      document.body.removeAttribute('style');
      window.scrollTo(0, this.scrollYPosition);
    }
  }

  onClose(data: any) {
    this.selectedDate = data;
    if (!this.open) {
      this.removeDatePicker();
    }
  }

  public getDate(): string {
    let unformattedDate;
    if (this.modelValue && !isNaN(this.modelValue.valueOf())) {
      if (this.ignoreTime) {
        let day = this.modelValue.getDate().toString();
        let month = (this.modelValue.getMonth() + 1).toString();
        const year = this.modelValue.getFullYear();
        if (month.length === 1) { // IE browser new Date() invalid date issue fix
          month = '0' + month;
        }
        if (day.length === 1) {
          day = '0' + day;
        }
        unformattedDate = year + '-' + month + '-' + day + ' 00:00:00';
      } else {
        unformattedDate = this.modelValue && this.modelValue.toISOString();
      }
      if (this.userFormat) {
        this.dateValueFormat = this.userFormat;
      } else {
        if (this.datepickerMode === 'month') {
          this.dateValueFormat = 'MMM YYYY';
        } else if (this.datepickerMode === 'year') {
          this.dateValueFormat = 'YYYY';
        } else {
          this.dateValueFormat = 'MMM DD, YYYY';
        }
      }
      return moment(new Date(unformattedDate)).format(this.dateValueFormat);
    } else {
      return this.errorMsg;
    }
  }



  removeDatePicker() {
    if (this.datePickerComponentRef) {
      this.datePickerComponentRef.instance.closeEvent.unsubscribe();
      this.datePickerComponentRef.instance.selectionDone.unsubscribe();
      this.datePickerComponentRef.destroy();
    }
    this.datePickerComponentRef = null;
    this.hideDatepicker();
    if (typeof this.unbindDocumentEvent === 'function') {
     this.unbindDocumentEvent();
    }
    this.datepickerService.destroyData();
    this.onDatepickerClose.emit(this.modelValue);
    this.formatedDate = moment(this.modelValue).format(this.userFormat);
    this.onTouched();
  }
  // Listener for document click event
  addDocumentListener() {
    this.unbindDocumentEvent = this.renderer.listen(
      document,
      'click',
      (event: Event) => {
        event.stopPropagation();
        if (this.closeDatePicker(event) && event.type !== 'key') {
          return;
        } else {
          this.removeDatePicker();
        }
      }
    );
  }

  closeDatePicker(event: Event): boolean {
    if (this.datePickerComponentRef) {
      this.monthPickerRef.push(
        this.datePickerComponentRef.instance._datePicker.datepickerMode
      );
      if (
        this.datePickerComponentRef.instance.el.nativeElement.contains(
          event.target
        ) ||
        this.datePickerComponentRef.instance.innerref.el.nativeElement.contains(
          event.target
        ) ||
        this.datePickerComponentRef.instance.innerref.daypickerref.el.nativeElement.contains(
          event.target
        ) ||
        this.datePickerComponentRef.instance.innerref.monthpickerref.el.nativeElement.contains(
          event.target
        ) ||
        (this.datePickerComponentRef.instance.el.nativeElement.nextSibling
          && this.datePickerComponentRef.instance.el.nativeElement.nextSibling
         .tagName === event.target['tagName'])
     ) {
        return true;
      } else if (
        this.monthPickerRef[this.monthPickerRef.length - 1] !==
        this.monthPickerRef[this.monthPickerRef.length - 2]
      ) {
        this.calculatePosition();
        return true;
      } else {
        return false;
      }
    }
  }
  disableDatepicker() {
    this.disabled = true;
  }
  enableDatepicker() {
    this.disabled = false;
  }
  toggleDatepicker() {
    this.disabled = !this.disabled;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
  // for ngModel implementing custom form ControlValueAccessor

  writeValue(value) {
    if (value) {
      this.modelValue = value;
      this.isValid = true;
      this.formatedDate = moment(this.modelValue).format(this.userFormat);
      this.inputValue = '';

      setTimeout(() => {
        this.inputValue = this.getDate();
        this.cdr.detectChanges();
      })
      
    } else {
      this.inputValue = '';
      this.modelValue = null;
      this.isValid = false;
    }
  }

  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
    this.isInitialLoadWriteValue = false;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  validate(
    control: FormControl
  ): {
    [key: string]: any;
  } {
    if (this.required) {
      this.inputValue = this.getDate();
      if (control.value) {
        if (this.maxDate) {
          this.validator = max(this.maxDate);
          if (this.validator(control)) {
            return this.validator(control);
          }
        }
        if (this.minDate) {
            this.validator = min(this.minDate);
            if (this.validator(control)) {
              return this.validator(control);
            }
          }
      } else {
        return {
          axisdatepicker: {
            valid: false
          },
          required: true
        };
      }
    } else {
      if (this.editedValue && !control.value) {
        return {
          axisdatepicker: {
            valid: false
          },
          required: true
        };
      } else {
        if (control.value) {
          if (this.maxDate) {
            this.validator = max(this.maxDate);
            if (this.validator(control)) {
              return this.validator(control);
            }
          }
          if (this.minDate) {
              this.validator = min(this.minDate);
              if (this.validator(control)) {
                return this.validator(control);
              }
          }
          return null;
        }
      }
    }
  }
  calculatePosition() {
    const menuElement = this.datePickerComponentRef.location.nativeElement;
    const hostElement = this.el.nativeElement;
    setTimeout(() => {
      if (this.datePickerComponentRef && this.datePickerComponentRef.location) {
        const posObj = hostElement.getBoundingClientRect();
        const menuPosObj = menuElement.getBoundingClientRect();
        this.smartPositioning(posObj, menuPosObj);
      }
    }, 0);
  }
  smartPositioning(posObj: any, menuPosObj: any) {
    const menuHeight = menuPosObj.height;
    if (
      window.innerHeight - (posObj.bottom + menuHeight) > 0 ||
      posObj.top - menuHeight < 0
    ) {
      this.bottomPositioning(posObj, menuPosObj);
    } else {
      this.topPositioning(posObj, menuPosObj, menuHeight);
    }
    }
  topPositioning(posObj: any, menuPosObj: any, menuHeight: number) {
    const top = posObj.bottom - menuHeight + this.scrollYPosition;
    if (window.innerWidth - (posObj.left + menuPosObj.width) > 0) {
      const left = posObj.left;
      this.datePickerComponentRef.location.nativeElement.style.left =
        left + 'px';
    } else {
      const right = window.innerWidth - posObj.right;
      this.datePickerComponentRef.location.nativeElement.style.right =
        right + 'px';
    }
    const datePickerPadding = this.localeLanguage.slice(0, 2).toLowerCase() === 'ja' ? this.el.nativeElement.clientHeight : 0;
    this.datePickerComponentRef.location.nativeElement.style.top =
     top - datePickerPadding + 'px'; // added 35px for repositioning of datepicker modal

  }
  bottomPositioning(posObj: any, menuPosObj: any) {
    const top = posObj.top + this.scrollYPosition;
    if (window.innerWidth - (posObj.left + menuPosObj.width) > 0) {
      const left = posObj.left;
      this.datePickerComponentRef.location.nativeElement.style.left =
        left + 'px';
    } else {
      const right = window.innerWidth - posObj.right;
      this.datePickerComponentRef.location.nativeElement.style.right =
        right + 'px';
    }
    const datePickerPadding = this.localeLanguage.slice(0, 2).toLowerCase() === 'ja' ? this.el.nativeElement.clientHeight : 0;
    this.datePickerComponentRef.location.nativeElement.style.top =
    top + datePickerPadding + 'px'; // added 35px for repositioning of datepicker modal
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}




